<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/promotions">
                    <icon name="money-bill-wave-alt"></icon>
                    โปรโมชั่น
                </b-nav-item>&nbsp
                <b-nav-item router-link to="promotions-other">
                    <icon name="bullhorn">
                    </icon>
                    โปรโมชั่นอื่นๆ
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "promotions-layout"
    }
</script>

<style scoped>

</style>